import React, { useState, useEffect } from "react";
import "./Profile.css";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import api from "../api";

function Profile() {
  const [formData, setFormData] = useState({
    fullName: "",
    gender: "",
    phone: "",
    complaint: "",
    emergencyName: "",
    emergencyPhone: "",
    emergencyEmail: "",
  });

  const [formDataFromDB, setFormDataFromDB] = useState({});
  const [profileImageUrl, setProfileImageUrl] = useState("/profile-pic.png");
  const [selectedImageFile, setSelectedImageFile] = useState(null);
  const token = localStorage.getItem("token");
  console.log("Token: ", token)

  useEffect(() => {
  const fetchProfile = async () => {
    try {
      const res = await api.post(
        "/api/profile/get", 
        {}, // POST body if needed, empty for now
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true, // axios equivalent of fetch's credentials: "include"
        }
      );

      const data = res.data; // axios gives you data directly
      console.log("Fetched profile data:", data);

      setFormData({
        fullName: data.fullName || "",
        gender: data.gender || "",
        phone: data.phone || "",
        complaint: data.complaint || "",
        emergencyName: data.emergencyName || "",
        emergencyPhone: data.emergencyPhone || "",
        emergencyEmail: data.emergencyEmail || "",
      });

      setFormDataFromDB(data);

      if (data.profileImageUrl) {
        setProfileImageUrl(data.profileImageUrl);
      }
    } catch (err) {
      console.error("Error fetching profile:", err);
    }
  };

  if (token) fetchProfile();
}, [token]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleImageSelection = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setSelectedImageFile(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      setProfileImageUrl(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleSave = async () => {
    let uploadedImageUrl = profileImageUrl;

    if (selectedImageFile) {
      const imageData = new FormData();
      imageData.append("profile_pic", selectedImageFile);
      imageData.append("fullName", formData.fullName || formDataFromDB.fullName || "user");

      try {
        const res = await api.post("/profile/upload-picture", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: imageData,
        });

        const result = await res.json();

        if (res.ok && result.imageUrl) {
          uploadedImageUrl = result.imageUrl;
          setProfileImageUrl(result.imageUrl);
        } else {
          alert("Image upload failed.");
          return;
        }
      } catch (error) {
        console.error("Image upload error:", error);
        alert("Error uploading image.");
        return;
      }
    }

    try {
      const res = await await api.post(
        "/profile",
        { ...formData, profileImageUrl: uploadedImageUrl },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert("Profile saved successfully!");
    } catch (err) {
      console.error(err);
      alert("Failed to save profile. Please try again.");
    }
  };

  return (
    <div className="profile-page">
      <Header />
      <div className="profile-body">
        <Sidebar />
        <div className="profile-content">
          <div className="profile-image-section">
            <img src={profileImageUrl} alt="profile" className="profile-image" />
            <input
              type="file"
              accept="image/*"
              id="profilePicInput"
              style={{ display: "none" }}
              onChange={handleImageSelection}
            />
            <label htmlFor="profilePicInput" className="edit-icon">
              ✏️
            </label>
          </div>

          <div className="profile-form">
            <div className="form-group-row">
              <div>
                <label>Full Name</label>
                <input
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder={formDataFromDB.fullName || "Full Name"}
                />
              </div>
              <div>
                <label>Gender</label>
                <select name="gender" value={formData.gender} onChange={handleChange}>
                  <option value="">Select gender</option>
                  <option>Female</option>
                  <option>Male</option>
                  <option>Other</option>
                </select>
              </div>
            </div>

            <div className="form-group-row">
              <div>
                <label>Phone Number</label>
                <input
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder={formDataFromDB.phone || "Phone Number"}
                />
              </div>
            </div>

            <div>
              <label>Complaint</label>
              <textarea
                name="complaint"
                value={formData.complaint}
                onChange={handleChange}
                placeholder={formDataFromDB.complaint || "Complaint"}
              />
            </div>

            <h3>Emergency Contact</h3>

            <div className="form-group-row">
              <div>
                <label>Full Name</label>
                <input
                  name="emergencyName"
                  value={formData.emergencyName}
                  onChange={handleChange}
                  placeholder={formDataFromDB.emergencyName || "Full Name"}
                />
              </div>
              <div>
                <label>Phone Number</label>
                <input
                  name="emergencyPhone"
                  value={formData.emergencyPhone}
                  onChange={handleChange}
                  placeholder={formDataFromDB.emergencyPhone || "Phone Number"}
                />
              </div>
            </div>

            <div>
              <label>Email</label>
              <input
                name="emergencyEmail"
                value={formData.emergencyEmail}
                onChange={handleChange}
                placeholder={formDataFromDB.emergencyEmail || "Email"}
              />
            </div>

            <button className="save-btn" onClick={handleSave}>
              Save Changes
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Profile;
